module.exports = [
  {
    country: "us",
    locale: "en_US",
    slugId: "enterprise-solutions-reimagine-customer-checkout",
    link: "https://pypd.paypal-mktg.com/l/925803/2021-09-14/2ftkg",
  },
];
